import React, { useState } from 'react'
import { Typography, useTheme, Grid, Box /* MobileStepper */ } from '@mui/material'
import SwipeableViews from 'react-swipeable-views'
import { autoPlay } from 'react-swipeable-views-utils'

import useStyles from './style'
import tutorialSteps, { TutorialSteps } from './constants'
import Tag from './Tag'

const AutoPlaySwipeableViews = autoPlay(SwipeableViews)

type Props = {
  handleBackground: (newGradient: string) => void
}

const ReleaseNotes = (props: Props) => {
  const classes = useStyles()
  const theme = useTheme()
  const [activeStep, setActiveStep] = useState(0)
  /*   const maxSteps = tutorialSteps.length */

  const handleStepChange = (step: number) => {
    setActiveStep(step)
    props.handleBackground(tutorialSteps[step].background || '')
  }

  const getSource = (step: TutorialSteps) => (theme.palette.mode === 'dark' ? step.imgPath : step.imgPathLight)

  return (
    <Grid container justifyContent="flex-start" alignItems="center" className={classes.root}>
      <Grid container className={classes.header}>
        <Grid container item direction="row" alignItems="center" xs={12} md={12} lg={12}>
          <Tag
            label={tutorialSteps[activeStep].labelTag}
            colorTag={tutorialSteps[activeStep].colorTag}
            colorText={tutorialSteps[activeStep].colorText}
          />
        </Grid>
        <Grid
          container
          item
          direction="row"
          alignItems="center"
          xs={12}
          md={12}
          lg={12}
          style={{ marginTop: 8, marginBottom: 24 }}
        >
          <Typography
            id={`header-slide${activeStep}`}
            variant="h1"
            color="text.primary"
            sx={{ fontWeight: 'bold', fontSize: '36px' }}
          >
            {tutorialSteps[activeStep].label}
          </Typography>
        </Grid>
      </Grid>

      <AutoPlaySwipeableViews
        id="main-slides-container"
        className="swipeable-views"
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={7000}
        style={{ width: '80%' }}
      >
        {tutorialSteps.map((step, index) => (
          <Box id={`content-slide${index}`} key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <React.Fragment key={index}>
                {step.isVideo ? (
                  <video id={`video-slide${index}`} className={classes.img} loop muted controls>
                    <source src={getSource(step)} type={step.type} />
                  </video>
                ) : (
                  <img id={`image-slide${index}`} className={classes.img} src={getSource(step)} alt={step.label} />
                )}
                {/*  <Box display="flex" justifyContent="start" marginBottom={5}>
                  <img
                    id={`image-slide${index}`}
                    src={getSource(step)}
                    alt={step.label}
                    style={{ minHeight: '300px' }}
                  />
                </Box>
         <Box>
                  <Typography
                    id={`title-slide${index}`}
                    variant="h1"
                    color="text.primary"
                    sx={{ fontWeight: 'bold', fontSize: '24px', marginBottom: '20px' }}
                  >
                    Principales novedades
                  </Typography>
                  <Typography
                    id={`title-slide${index}`}
                    variant="h1"
                    color="text.primary"
                    sx={{ fontWeight: 'bold', fontSize: '24px', marginBottom: '20px' }}
                  >
                    {step.description}
                  </Typography>
                </Box> */}
              </React.Fragment>
            ) : null}
          </Box>
        ))}
      </AutoPlaySwipeableViews>

      <Grid className={classes.footerCarrusel}>
        <Grid item xs={12} md={12} lg={12}>
          <Typography
            id={`footer-slide-${tutorialSteps[activeStep].labelTag}`}
            variant="body1"
            color="text.primary"
            sx={{ fontWeight: '300', fontSize: '20px !important' }}
          >
            {tutorialSteps[activeStep].description}
          </Typography>
        </Grid>
      </Grid>
      {/*  <Grid
        item
        display="center"
        justifyContent="center"
        xs={12}
        md={12}
        lg={12}
        style={{ marginTop: 20, marginBottom: 20 }}
      >
        <MobileStepper
          id="mobile-stepper"
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          nextButton={null}
          backButton={null}
          style={{
            background: 'transparent'
          }}
        />
      </Grid> */}
    </Grid>
  )
}

export default ReleaseNotes
